import PublicLayout from '@/components/layout/PublicLayout';
import { agbContent } from '@/content/legal/agb';

export default function AGBPage() {
  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 p-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
            {agbContent.title}
          </h1>

          {agbContent.sections.map((section, index) => (
            <div key={index} className="mb-8 last:mb-0">
              {section.title && (
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  {section.title}
                </h2>
              )}
              <div className="space-y-2 text-gray-700 dark:text-gray-300">
                {section.content.map((paragraph, pIndex) => (
                  paragraph === '' ? (
                    <div key={pIndex} className="h-2"></div>
                  ) : (
                    <p key={pIndex} className="leading-relaxed">
                      {paragraph}
                    </p>
                  )
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
